import { Avatar, Flex, List, Tooltip, Typography } from "antd";
import { HeadingText } from "../../generic/Typography";
import { formatPhoneNumber } from "../../../utils/phoneLib";
import phoneImg from "../../../assets/images/icon/Phone-call.svg";
import { FaUsersCog } from "react-icons/fa";
import { FcRules } from "react-icons/fc";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/store";
import { setSelectedView } from "../../../store/slices/admin.slice";
import { FaInfoCircle } from "react-icons/fa";
import { usePermissions } from "../../../hooks/permissions";
import { Did } from "../../../interfaces/Did.type";

const cardStyle = {
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    cursor: "pointer"
};

const didCardStyle: React.CSSProperties = {
    width: "100%",
    borderRadius: 6
};

const avatarStyle: React.CSSProperties = {
    height: "1.2rem",
    width: "1.2rem",
    marginTop: "2px",
    marginRight: "10px"
};

const didlabelStyle: React.CSSProperties = {
    color: "rgb(119, 117, 135)",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    width: "fit-content",
    maxWidth: "230px"
}

const DidItem = ({
    did,
    onClick,
    selectedDid,

}: {
    did: Did;
    onClick: Function;
    selectedDid: Did | null;

}) => {
    const dispatch: AppDispatch = useDispatch();

    const { hasPermission, hasPermission2 } = usePermissions();

    const handleView = (view: string) => {
        dispatch(setSelectedView(view));
    };

    return (
        <>
  
            <List.Item
                style={{
                    ...cardStyle,
                    background: selectedDid && selectedDid.did === did.did ? "#eff4fb" : "#fff"
                }}
                onClick={() => onClick(did)}
            >
                <Flex justify="space-between" style={didCardStyle}>
                    <Flex>
                        <Avatar style={avatarStyle} src={phoneImg} />

                        <Flex vertical={true}>
                            <HeadingText text={formatPhoneNumber(did.did) as string}></HeadingText>
                            <Tooltip title={did.label}>
                                <Typography.Text style={didlabelStyle}>{did.label}</Typography.Text>
                            </Tooltip>
                        </Flex>
                    </Flex>
                    <Flex gap={"10px"}>
                        {(hasPermission("sms", ["readUserDids:any", "readUserDids:account"]) || hasPermission2("sms.user_dids.view", "account")) && (
                            <Tooltip title="Assigned Users" color="blue">
                                <FaUsersCog color="rgb(101, 59, 250)" onClick={() => handleView("userDids")} />
                            </Tooltip>
                        )}
                        {(hasPermission("sms", ["readAutoReplyRules:any", "readAutoReplyRules:account"]) || hasPermission2("sms.auto_reply_rules.view", "account")) && (
                            <Tooltip title="Auto Reply Rules" color="blue">
                                <FcRules color="rgb(101, 59, 250)" onClick={() => handleView("rules")} />
                            </Tooltip>
                        )}

                        {(hasPermission("sms", ["readDids:any", "readDids:account"]) || hasPermission2("sms.dids.view", "account")) && (
                            <Tooltip title="Info" color="blue">
                                <FaInfoCircle color="rgb(101, 59, 250)" onClick={() => handleView("info")} />
                            </Tooltip>
                        )}
                    </Flex>
                </Flex>
            </List.Item>
        </>
    );
};

export default DidItem;
